import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Short confirmations ("Address copied", "Saved") that fade out after a few seconds (step 5, D80).
 * Call `toast("…")` from anywhere; mount <Toaster /> once per app. Screen readers hear them
 * (role="status"). Never put amounts or personal data in a toast.
 */
import { CheckCircle2, XCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { cn } from "./cn.js";
let items = [];
let nextId = 1;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l(items));
export function toast(text, tone = "success") {
    const id = nextId++;
    items = [...items.slice(-2), { id, text, tone }];
    emit();
    setTimeout(() => {
        items = items.filter((t) => t.id !== id);
        emit();
    }, 3200);
}
export function Toaster() {
    const [list, setList] = useState(items);
    useEffect(() => {
        listeners.add(setList);
        return () => {
            listeners.delete(setList);
        };
    }, []);
    return (_jsx("div", { "aria-live": "polite", className: "pointer-events-none fixed inset-x-0 top-[calc(0.75rem+env(safe-area-inset-top))] z-50 flex flex-col items-center gap-2 px-4", children: list.map((t) => (_jsxs("div", { role: "status", "data-testid": "toast", className: cn("animate-rise pointer-events-auto flex items-center gap-2 rounded-full border bg-surface/95 px-4 py-2.5 text-sm text-fg shadow-2xl backdrop-blur-xl", t.tone === "success" ? "border-line" : "border-danger/40"), children: [t.tone === "success" ? (_jsx(CheckCircle2, { className: "size-4 text-success", "aria-hidden": true })) : (_jsx(XCircle, { className: "size-4 text-danger", "aria-hidden": true })), t.text] }, t.id))) }));
}
//# sourceMappingURL=Toast.js.map